import { Routes, Route } from 'react-router-dom'
import { DocsLayout } from './components/DocsLayout'
import { DocsHome } from './pages/DocsHome'
import { DocsPlugin } from './pages/DocsPlugin'
import { DocsPageView } from './pages/DocsPageView'
import { SupportPage } from './pages/SupportPage'

function App() {
  return (
    <Routes>
      <Route path="/" element={<DocsLayout />}>
        <Route index element={<DocsHome />} />
        <Route path="support" element={<SupportPage />} />
        <Route path=":pluginSlug" element={<DocsPlugin />} />
        <Route path=":pluginSlug/:sectionSlug/:pageSlug" element={<DocsPageView />} />
      </Route>
    </Routes>
  )
}

export default App
